import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=c628af56&scoped=true&"
import script from "./productDialog.vue?vue&type=script&lang=js&"
export * from "./productDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c628af56",
  null
  
)

export default component.exports